import React from 'react'
import "./RechargeCenter.less";
import { appMethod as app } from '@utils/app';
import { Toast } from 'antd-mobile';

export default class RechargeCenter extends React.Component {
  state = {
    intergal: {
      list: [],
      showList: [],
      page: 1,
      totalPage: 0,
    },
    vip: {
      list: [],
      showList: [],
      page: 1,
      totalPage: 0,
    },
    type: null,
    code: '',
    selectId: '',
    selectPrice: null,
    shouldPayPrice: 0,
    timer: null,
    orderId: '',
  }
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    if (app.isLogin()) {
      this.getVipInfo();
      this.getIntegralInfo();
    }else{
      app.turnToPage('login-pc');
    }
  }
  componentWillUnmount() {
    this.setState = (state,callback)=>{
      return;
    };
    clearInterval(this.state.timer)
  }
  cancel= () => {
    this.props.cancelDialog('rechargeCenter');
  }
  getIntegralInfo = () => {
    let that = this;
    app.showLoading({
      title: '加载中..',
    })
    app.sendRequest({
      url: '/index.php?r=ChatAI/GetChatIntegralConfigList',
      hideLoading: true,
      data: {
        app_id: app.getAppId(),
        card_type: 2
      },
      success: (res) => {
        let returnIntegralList = res.data || [];
        that.setState({
          intergal: {
            list: returnIntegralList,
            showList: returnIntegralList.slice(0,4),
            totalPage:  Math.ceil(returnIntegralList.length/4),
            page: 1,
          },
          // selectId: returnIntegralList.length?returnIntegralList[0].id:'',
          // selectPrice: returnIntegralList.length?returnIntegralList[0].price:null,
        })
        // if(returnIntegralList.length){
        //   that.selectItem();
        // }
      }
    })
  }
  getVipInfo = () => {
    let that = this;
    app.showLoading({
      title: '加载中..',
    })
    app.sendRequest({
      url: '/index.php?r=appVipCard/getUserAccountSurvey',
      hideLoading: true,
      data: {
        app_id: app.getAppId(),
        card_type: 2
      },
      success: (res) => {
        let returnVipList = res.data.all_vip_card || [];
        that.setState({
          vip: {
            list: returnVipList,
            totalPage: Math.ceil(returnVipList.length/4),
            showList: returnVipList.slice(0,4),
            page: 1,
          }
          // selectId: returnVipList.length?returnVipList[0].id:'',
          // selectPrice: returnVipList.length?returnVipList[0].price:null,
          // selectComboid: returnVipList.length?returnVipList[0].combo[0].id:''
        })
        // if(returnVipList.length){
        //   that.selectItem();
        // }
      }
    })
  }

  nextPage = () => {
    let { page, list, totalPage } = this.state.intergal;
    console.log(page)
    if(page >= totalPage){
      Toast.info('后面已经没有了')
      return
    }
    let c_page = page + 1;
    let start = page*4;
    let end = start + 4;
    this.setState({
      intergal: {
        page: c_page,
        showList: list.slice(start,end)
      },
    })
  }
  prePage = () => {
    let { page, list } = this.state.intergal;
    if(page <= 1){
      Toast.info('前面已经没有了')
      return
    }
    let c_page = page - 1;
    let start = c_page*4 - 4;
    let end = start + 4;
    this.setState({
      intergal: {
        page: c_page,
        showList: list.slice(start,end)
      },
    })
  }
  nextPage2 = () => {
    let { page, list, totalPage } = this.state.vip;
    console.log(page)
    if(page >= totalPage){
      Toast.info('后面已经没有了')
      return
    }
    let c_page = page + 1;
    let start = page*4;
    let end = start + 4;
    this.setState({
      intergal: {
        page: c_page,
        showList: list.slice(start,end)
      },
    })
  }
  prePage2 = () => {
    let { page, list } = this.state.vip;
    if(page <= 1){
      Toast.info('前面已经没有了')
      return
    }
    let c_page = page - 1;
    let start = c_page*4 - 4;
    let end = start + 4;
    this.setState({
      intergal: {
        page: c_page,
        showList: list.slice(start,end)
      },
    })
  }
  selectItem = (event = false) => {
    let that = this;
    let id = event ? event.currentTarget.dataset.id : that.state.selectId;
    let type = event ? event.currentTarget.dataset.type : that.state.type;
    let price = event ? event.currentTarget.dataset.price : that.state.selectPrice;
    let comboid = type == 2 ? event.currentTarget.dataset.comboid : '';

    let integralurl = '/index.php?r=ChatAI/CreateOrder'
    let vipurl = '/index.php?r=appVipCard/addPaidVipCardOrder'
    let parms1 = {
      app_id: app.getAppId(),
      integral_config_id: id,
      goods_type: 17,
    }
    let parms2 = {
      app_id: app.getAppId(),
      data_id: id,
      price: price,
      combo_id: comboid,
    }
    this.setState({
      selectId: id,
      shouldPayPrice: price,
      type: type
    })
    if(that.state.timer) {
      clearInterval(that.state.timer);
    }
    app.sendRequest({
      url: type == 1?integralurl:vipurl,
      method: 'post',
      data: type == 1?parms1:parms2,
      hideLoading: false,
      complete: function (res) {
        if(res.status != 0){
          that.setState({
            selectId: '',
            selectPrice: null,
            selectComboid: '',
            shouldPayPrice: 0,
            type: null
          })
          return
        }
        let orderId = res.data;
        that.setState({
          orderId: orderId
        })
        that.getPayCode(orderId);
      }
    })
  }
  getPayCode = (orderId) => {
    let that = this;
    app.showLoading({
      title: '加载中..',
    })
    app.sendRequest({
      url: '/index.php?r=pay/Pay/GetUniPay',
      data: {
        order_id: orderId,
        payment_id: 0,
      },
      hideLoading: true,
      success: function (res) {
        if(res.status == 0){
          that.setState({
            code: res.data
          })
          let timer = setInterval(() => {
            that.isPay(orderId);
          }, 3000);
          that.setState({
            timer: timer
          })
        }
      }
    })
  }
  isPay = (orderId) => {
    let that = this;
    app.sendRequest({
      url:'/index.php?r=AppShop/CheckOrder',
      method: 'post',
      data: {
        order_id: orderId  || that.state.orderId
      },
      success: function (res) {
        if (res.status != 0) {
          Toast.info(res.data);
          return;
        }
        switch(res.data.status) {
          case '0':  // 订单未支付
            break;
          case '1': // 订单支付完成
            Toast.info('订单支付完成');
            clearInterval(that.state.timer);
            that.props.cancelDialog('rechargeCenter',that.state.type);
            break;
          case '6': // 订单支付完成
            Toast.info('订单支付完成');
            clearInterval(that.state.timer);
            that.props.cancelDialog('rechargeCenter',that.state.type);
            break;
        }
      }
    })
  }
  render() {
    return (
      <div className='rechargeCenterDialog'>
        <div className='mask' onClick={this.cancel}></div>
        <div className='content'>
          <label className='ico-moon icon-closes closes_btn' onClick={this.cancel}></label>
          <div className='head'>
            充值中心
          </div>
          <div className='main'>
            {this.state.intergal.showList.length != 0 && (
              <div className='r_item_box'>
              <div className='item_title'>
                <img src="http://cdn.jisuapp.cn/static/webapp/images/chatgpt/item5.png" />
                <span>积分充值</span>
              </div>
              <img className='next_item' src="http://cdn.jisuapp.cn/static/webapp/images/chatgpt/next.png" onClick={this.nextPage}/>
              <img className='pre_item' src="http://cdn.jisuapp.cn/static/webapp/images/chatgpt/next.png" onClick={this.prePage}/>
              <div className='item_list'>
                {this.state.intergal.showList.map((item,index) => 
                <div className={'item ' + (this.state.selectId == item.id && this.state.type == 1?'active': '')} key={index} onClick={this.selectItem} data-type={1} data-id={item.id} data-price={item.price}>
                  <div className='num'>{item.num}积分</div>
                  <div className='price'>{item.price}元</div>
                </div>
                )}
              </div>
            </div>
            )}
            {this.state.vip.showList.length != 0 && (
              <div className='r_item_box mar_t20' >
              <div className='item_title'>
                <img src="http://cdn.jisuapp.cn/static/webapp/images/chatgpt/item4.png" />
                <span>开通会员</span>
              </div>
              <img className='next_item' src="http://cdn.jisuapp.cn/static/webapp/images/chatgpt/next.png" onClick={this.nextPage2}/>
              <img className='pre_item' src="http://cdn.jisuapp.cn/static/webapp/images/chatgpt/next.png" onClick={this.prePage2}/>
              <div className='item_list'>
                {this.state.vip.showList.map((item,index) => 
                <div className={'vipitem ' + (this.state.selectId == item.id && this.state.type == 2?'active': '')} key={index} onClick={this.selectItem} data-type={2} data-comboid={item.combo[0].id} data-id={item.id} data-price={item.combo[0].price}>
                  <div className='name'>{item.title}</div>
                  <div className='price2'>
                    <div className='mar_r10'><span>￥</span>{item.combo[0].price}</div>
                    <div className='dsc through'>原价￥{item.price}</div>
                  </div>
                  <div className='dsc'>{(item.combo[0].price/30).toFixed(2)}元/天</div>
                </div>
                )}
              </div>
            </div>
            )}
            {this.state.code != '' && 
            <div className='recharge_box'>
              <div className='code'>
                <img src={this.state.code}/>
              </div>
              <div className='info'>
                <div className='wxzf'>
                  <img src="http://cdn.jisuapp.cn/static/webapp/images/chatgpt/wxlog.png" alt="" />
                  <span>微信支付</span>
                </div>
                <div className='info_line'>
                  <div className='name'>应付金额:</div>
                  <div className='price'>￥<span>{this.state.shouldPayPrice}</span></div>
                </div>
                <div className='dsc'>支付视为您同意<a target="_blank" href="http://bbs.zhichiwangluo.com/forum.php?mod=viewthread&tid=11189&page=1&extra=#pid12695">《咫尺支付协议》</a></div>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/chatgpt-page/component/RechargeCenter/RechargeCenter.jsx